import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Project = ({pageData, containerData, content, images, styles}) => {
  // Initialize AOS (Animate On Scroll) library
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  return (
    <div
      data-elementor-type={pageData.elementorType}
      data-elementor-id={pageData.elementorId}
      className={pageData.className}
    >
      <div
        className={containerData.className}
        data-id={containerData.dataId}
        data-aos={containerData.aos}
        data-aos-offset={containerData.aosOffset} 
        data-aos-easing={containerData.aosEasing} 
        data-aos-duration={containerData.aosDuration}
        data-element_type={containerData.elementType}
        style={containerData.style}
      >
        <div className="elementor-widget-container">
          <div className="world-trade-centre">
            <div className="top-lines" aria-hidden="true">
              <hr className="top-line" data-aos="fade-right" data-aos-delay="100" />
              <hr className="top-line" data-aos="fade-left" data-aos-delay="100" />
            </div>

            <div className="container" role="main">
              {/* Left section */}
              <section className="left-section" aria-labelledby="heading-main">
                <hr data-aos="fade-right" data-aos-delay="200" />
                <h1 id="heading-main" data-aos="fade-up" data-aos-delay="300">{content.title}</h1>
                {content.subtitle && <h2 data-aos="fade-up" data-aos-delay="350">{content.subtitle}</h2>}
               
                {content.subp && <p data-aos="fade-up" data-aos-delay="400">{content.subp}</p>}
               

                <section 
                  className="key-features" 
                  aria-labelledby="features-heading"
                  data-aos="fade-up"
                  data-aos-delay="450"
                >
                  <h3 id="features-heading">{content.keyFeatures.title}</h3>
                  <ul className="features-list" aria-describedby="features-desc">
                    {content.keyFeatures.items.map((item, index) => (
                      <li 
                        key={index}
                        data-aos="fade-up"
                        data-aos-delay={450 + (index * 50)}
                      >
                        <span>{item}</span>
                        <span className="checkmark" aria-hidden="true">✓</span>
                      </li>
                    ))}
                  </ul>
                </section>
                <aside>
                  <p 
                    className="vision-quote" 
                    style={styles.visionQuoteStyle}
                    data-aos="fade-up"
                    data-aos-delay="550"
                  >
                    {content.visionQuote}
                  </p>
                </aside>
                <blockquote 
                  className="quote-container"
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  <p className="quote-text">{content.clientQuote.text}</p>
                  <footer className="quote-author">{content.clientQuote.author}</footer>
                </blockquote>
              </section>

              {/* Right section */}
              <section className="right-section" aria-label="Project images">
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={image.className || ''}
                    data-aos={index === 0 ? "zoom-in" : "fade-up"}
                    data-aos-delay={index === 0 ? 300 : 400 + (index * 100)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = image.src.includes('wtc-featured') 
                        ? '/projectsimg/main/wtc-featured-800x600.jpg'
                        : 'https://storage.googleapis.com/workspace-0f70711f-8b4e-4d94-86f1-2a93ccde5887/image/be910e43-31ad-4ffc-89fb-3001e2fd976a.png';
                    }}
                  />
                ))}
              </section>
            </div>

            <style jsx>{`
              /* Reset and base */
              * {
                box-sizing: border-box;
              }
              .world-trade-centre {
                font-family: Georgia, serif;
                margin: 0;
                padding: 40px 60px;
                color: #444;
                background: #fff;
                line-height: 1.5;
              }
              hr {
                border: none;
                border-top: 1px solid #444;
                margin: 30px 0;
                width: 70px;
                opacity: 0.6;
              }
              h1, h2, h3 {
                margin: 0;
                line-height: 1.1em;
              }
              h1 {
                font-size: 3.1rem;
                font-weight: 700;
                color: #333;
                letter-spacing: -0.03em;
              }
              h2 {
                font-size: 28px !important;
                font-weight: 600;
                color: #222;
                margin-bottom: 10px;
              }
              h3 {
                font-size: 22px !important;
                font-weight: 400;
              }
              b {
                font-weight: 700;
              }
              a {
                color: #006699;
              }
              /* Layout */
              .container {
                display: grid;
                grid-template-columns: 1fr 580px;
                gap: 40px;
                max-width: 1200px;
                margin: 0 auto;
              }
              .left-section {
                display: flex;
                flex-direction: column;
                gap: 20px;
              }
              .left-section > hr {
                width: 100px;
                margin-top: 0;
                opacity: 0.4;
              }
              /* Key Features and list */
              .key-features {
                max-width: 380px;
              }
              .key-features > hr {
                margin-bottom: 24px;
              }
              ul.features-list {
                list-style: none;
                padding: 0;
                margin: 0;
                border-top: 1px solid #444;
                border-bottom: 1px solid #444;
              }
              ul.features-list li {
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #ccc;
                padding: 6px 0;
                font-size: 0.875rem;
                color: #444;
                transition: all 0.3s ease;
              }
              ul.features-list li:hover {
                background-color: #f9f9f9;
                transform: translateX(5px);
              }
              ul.features-list li:last-child {
                border-bottom: none;
              }
              /* Tick/checkmark style */
              .checkmark {
                font-weight: 700;
                font-size: 1.1rem;
                color: #555;
                user-select: none;
                transition: transform 0.3s ease;
              }
              ul.features-list li:hover .checkmark {
                transform: scale(1.2);
                color: #006699;
              }
              /* Quote style */
              .quote-container {
                border-left: 3px solid #444;
                padding-left: 15px;
                margin-top: 30px;
                max-width: 380px;
                font-size: 0.9rem;
                color: #333;
                transition: all 0.3s ease;
              }
              .quote-container:hover {
                border-left-color: #006699;
                transform: translateY(-3px);
              }
              /* Small italic quote text */
              .quote-text {
                margin: 0 0 10px 0;
                font-style: italic;
                opacity: 0.8;
              }
              /* Quote author */
              .quote-author {
                font-weight: 700;
                opacity: 0.9;
                font-size: 0.85rem;
              }
              /* Vision quote inside right content text */
              .vision-quote {
                max-width: 260px;
                font-size: 0.9rem;
                color: #333;
                margin-top: 0;
                margin-bottom: 0;
                line-height: 1.4;
                font-style: normal;
                border-left: 2px solid #444;
                padding-left: 14px;
                opacity: 0.9;
                font-weight: 500;
                transition: all 0.3s ease;
              }
              .vision-quote:hover {
                border-left-color: #006699;
                transform: translateX(5px);
              }
              /* Right section grid for images */
              .right-section {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-template-rows: 517px 300px;
                gap: 10px;
              }
              .right-section .img-large {
                grid-column: 1 / 3;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 3px;
                box-shadow: 0 1px 8px rgb(0 0 0 / 0.1);
                transition: all 0.5s ease;
              }
              .right-section img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 3px;
                box-shadow: 0 1px 6px rgb(0 0 0 / 0.1);
                transition: all 0.5s ease;
              }
              .right-section img:hover {
                transform: scale(1.02);
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
              }
              /* PMC Logo placement bottom left */
              .footer-logo {
                position: fixed;
                bottom: 24px;
                left: 24px;
                max-width: 90px;
                user-select: none;
              }
              /* Horizontal lines top left and right */
              .top-lines {
                position: fixed;
                width: 100%;
                top: 20px;
                left: 0;
                display: flex;
                justify-content: space-between;
                padding: 0 60px;
                pointer-events: none;
                z-index: 1;
              }
              .top-line {
                border-top: 1px solid #555;
                width: 80px;
                opacity: 0.6;
                margin: 0;
                height: 1px;
                transform: translateY(-3px);
              }
              /* Responsive adjustments */
              @media (max-width: 900px) {
                .world-trade-centre {
                  padding: 20px 30px;
                }
                .container {
                  grid-template-columns: 1fr;
                  gap: 30px;
                }
                .right-section {
                  grid-template-columns: 1fr 1fr;
                  grid-template-rows: auto;
                  gap: 10px;
                }
                .right-section .img-large {
                  grid-column: 1 / 3;
                  height: 100%;
                }
                .right-section img {
                  height: 120px;
                }
                .key-features, .quote-container {
                  max-width: 100%;
                }
                .vision-quote {
                  max-width: 100%;
                  margin-top: 15px;
                  border-left: none;
                  padding-left: 0;
                }
                .top-lines {
                  padding: 0 30px;
                }
                .top-line {
                  width: 60px;
                }
                .footer-logo {
                  max-width: 80px;
                  bottom: 12px;
                  left: 12px;
                }
              }

              /* Animation classes */
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }

              .animate-fade-in {
                animation: fadeIn 1s ease-in-out;
              }
            `}</style>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project